import { Clips } from './Clips';

const clips = document.querySelectorAll('.tx-avmplugins-clips');

clips.forEach((element) => {
    new Clips(element);
});
